export default __webpack_public_path__ + "static/media/HAT1567.3ada1171.jpg";